var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIoSAppDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0084ff;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "E-Commerce_Web_App_Development",
    "data-name": "E-Commerce Web App Development"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,10A10,10,0,0,1,10,0H40A10,10,0,0,1,50,10V40A10,10,0,0,1,40,50H10A10,10,0,0,1,0,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.45,9a7.33,7.33,0,0,0-4.77,2.58,6.36,6.36,0,0,0-1.56,5,6.19,6.19,0,0,0,4.81-2.46A6.88,6.88,0,0,0,31.45,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.07,19.53a8,8,0,0,0-6-3.18c-2.82,0-4,1.34-6,1.34s-3.55-1.34-6-1.34a8.15,8.15,0,0,0-6.56,4c-2.27,3.52-1.88,10.14,1.8,15.78,1.32,2,3.07,4.29,5.37,4.31,2.05,0,2.63-1.32,5.4-1.33s3.3,1.34,5.34,1.32c2.31,0,4.16-2.53,5.48-4.55A22.53,22.53,0,0,0,39,32,6.93,6.93,0,0,1,38.07,19.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIoSAppDevelopment);
export default __webpack_public_path__ + "static/media/IoS-App-Development.fd50d72fdd02d57e08d0ade9edb16f04.svg";
export { ForwardRef as ReactComponent };